import React, { useState } from 'react'
import emailjs from 'emailjs-com';
import './ServicesAll.scss'
import { Helmet } from "react-helmet";
import NavigatorPath from "../../Tools/NavigatorPath/NavigatorPath"
import { useNavigate } from 'react-router-dom';
import Chimney3 from '../../Images/Chimney3.jpeg'
import bgnobgs from '../../Images/bgnobgs.png'
import AreaData from '../ServicesPage/AreaData'

export default function ServicesAll() {
    const navigate = useNavigate()


    return (
        <div className="ServicesAll">
            <Helmet>
                <title>Services | Rocket Air Care - Air Duct, HVAC, Chimney, Dryer & Roofing</title>
                <meta name="title" property="title" content="Services | Rocket Air Care" data-react-helmet="true" />
                <meta name="og:title" property="og:title" content="Services | Rocket Air Care" data-react-helmet="true" />
                <meta name="og:locale" property="og:locale" content="en_US" data-react-helmet="true" />
                <meta name="og:type" property="og:type" content="website" data-react-helmet="true" />
                <meta name="og:image" property="og:image" content="https://www.rocketaircare.com/og.jpg" data-react-helmet="true" />
                <meta name="og:url" property="og:url" content="https://www.rocketaircare.com/services" data-react-helmet="true" />
                <link rel="canonical" href="https://www.rocketaircare.com/services" />
                <meta name="description" content="Rocket Air Care service catalog — air duct cleaning, HVAC repair, chimney sweep, dryer vent cleaning, roof repair and more. Call 866-950-4606." data-react-helmet="true" />
                <meta name="og:description" property="og:description" content="Rocket Air Care service catalog." data-react-helmet="true" />
                <meta name="og:site_name" property="og:site_name" content="Rocket Air Care" data-react-helmet="true" />
                <meta name="keywords" content="air duct cleaning, HVAC repair, HVAC installation, chimney sweep, dryer vent cleaning, roof repair, roof replacement, gutter installation, home services, Rocket Air Care" data-react-helmet="true" />
                <meta name="robots" content="index, follow, max-image-preview:large" />
                <script type="application/ld+json">{JSON.stringify({
                    "@context": "https://schema.org",
                    "@type": "ItemList",
                    "name": "Rocket Air Care — Services",
                    "url": "https://www.rocketaircare.com/services",
                    "itemListElement": AreaData.map((A, i) => ({
                        "@type": "ListItem",
                        "position": i + 1,
                        "name": A.Title,
                        "url": `https://www.rocketaircare.com${A.Path}`
                    }))
                })}</script>
            </Helmet>
            <div className="ServicesAllTitle">
                <h1>Complete Home Services — Air Duct, HVAC, Chimney, Dryer & Roofing</h1>
                <h2>At Rocket Air Care, we offer a full range of professional home services — air duct cleaning, HVAC repair and installation, chimney sweep and inspection, dryer vent cleaning, and roofing. Our skilled technicians keep your home safe, comfortable, and energy efficient. Explore our services below and trust Rocket Air Care to deliver the quality and reliability you deserve.</h2>
            </div>
            <div className="ServicesAllLsit">
                {AreaData.map((A, index) =>
                    <a href={A.Path} className="Header1BoxMenuBox">
                        
                        <div className="ServicesAllBox">
                            <h2>{A.Title}</h2>
                            <h6>{A.TitleShortVery}</h6>
                            <h4>{A.Full}</h4>
                            <h5>EXPLORE THIS SERVICE</h5>
                        </div>
                    </a>
                )}
            </div>

            <NavigatorPath />

        </div>
    )
}

